import React from "react";
import { Grid, Typography, Box } from "@material-ui/core";
import intl from "react-intl-universal";

import { IWithballData } from "types";
import { StatisticsBoard } from "components/StatisticsBoard";

interface IDisciplinePanelProps {
  foulDataArray: IWithballData[];
  yellowCardDataArray: IWithballData[];
  redCardDataArray: IWithballData[];
}

export const DisciplinePanel = ({
  foulDataArray,
  yellowCardDataArray,
  redCardDataArray,
}: IDisciplinePanelProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Typography variant="h4">{`${intl.get("STATS_LABEL_FOUL")}: ${
          foulDataArray.length
        }`}</Typography>
        <Box mt={1} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <StatisticsBoard data={foulDataArray} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h4">{`${intl.get("STATS_LABEL_YELLOW")}: ${
          yellowCardDataArray.length
        }`}</Typography>
        <Box mt={1} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <StatisticsBoard data={yellowCardDataArray} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="h4">{`${intl.get("STATS_LABEL_RED")}: ${
          redCardDataArray.length
        }`}</Typography>
        <Box mt={1} />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <StatisticsBoard data={redCardDataArray} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
